import { render } from "./CardEmailInstitucional.vue?vue&type=template&id=32f4fb71"
import script from "./CardEmailInstitucional.vue?vue&type=script&lang=js"
export * from "./CardEmailInstitucional.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rhylton/Sites/intranet/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__